import React, { useMemo } from 'react'
import { Marker } from '@react-google-maps/api'
import { renderToStaticMarkup } from 'react-dom/server'
import { MapPin, Flag } from 'lucide-react'

const iconToDataURL = (IconComponent, fill, size = 32) => {
  // Render lucide icon with fill + no stroke
  const svgString = renderToStaticMarkup(
    <IconComponent size={size} stroke='none' fill={fill} />
  )

  const finalSvg = svgString.includes('xmlns=')
    ? svgString
    : svgString.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"')

  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(finalSvg)}`
}

const TrackMarkers = ({ track }) => {
  // unconditionally create data URLs (hooks must always run)
  const startIcon = useMemo(() => iconToDataURL(MapPin, '#FF0000', 32), [])
  const endIcon = useMemo(() => iconToDataURL(Flag, '#FF7A00', 32), [])

  // your original logic – unchanged
  if (!track.points || track.points.length === 0) return null
  if (track.status === 'active') return null

  const startPoint = track.points[0]
  const endPoint = track.points[track.points.length - 1]

  return (
    <>
      {/* Start Point — solid red pin */}
      <Marker
        position={{ lat: startPoint.latitude, lng: startPoint.longitude }}
        icon={{
          url:
            'data:image/svg+xml;base64,' +
            btoa(`
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" fill="#00d084" stroke="white" stroke-width="2"/>
              <circle cx="12" cy="12" r="4" fill="white"/>
            </svg>
          `),
          scaledSize: new window.google.maps.Size(24, 24),
          anchor: new window.google.maps.Point(12, 12)
        }}
        title={`Start - Track ${track.id}`}
        zIndex={1002}
      />

      {/* End Point — solid orange flag */}
      {endPoint && (
        <Marker
          position={{ lat: endPoint.latitude, lng: endPoint.longitude }}
          icon={{
            url:
              'data:image/svg+xml;base64,' +
              btoa(`
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#eb144c" stroke="white" stroke-width="2"/>
                <circle cx="12" cy="12" r="4" fill="white"/>
              </svg>
            `),
            scaledSize: new window.google.maps.Size(24, 24),
            anchor: new window.google.maps.Point(12, 12)
          }}
          title={`End - Track ${track.id}`}
          zIndex={1002}
        />
      )}
    </>
  )
}

export default TrackMarkers
